
import React, {Fragment} from "react";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {getDie} from "../_helper/dice";
import {s_char} from "../_signals/s_char";
import {IRoller} from "../_interfaces/IRoller";
import {vsRangesDisciplineRollInRange, vsRangesStepRollInRange} from "../_helper/vsRanges";
import {Chip} from "@mui/material";

const Item = styled("div")(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 4,
    textAlign: 'left',
    color: '#000',
}));

interface RollerResultProps {
    roller: IRoller;
}

const RollerResult: React.FC<RollerResultProps> = ({ roller }) => {
    const dateOptions = {year: 'numeric', month: '2-digit', day: '2-digit'} as const;

    const roll = roller.roll;
    const result = roller.result;

    const stepRange = vsRangesStepRollInRange(result.step + result.step_mod, result.result)
    const distRange = vsRangesDisciplineRollInRange(result.result)

    const date = new Date(result.time);
    const time = date.toLocaleTimeString('de-DE', dateOptions);
    const die = getDie(result.step + result.step_mod);

    return (
        <Paper style={{marginTop: 10, padding: 8}}>
            {time ? <Item>{time}</Item> : result.time}
            <Item>Stufe: {result.step + result.step_mod} {s_char.value.wunden > 0 && <span>( - {s_char.value.wunden} Wunden)</span>}</Item>
            <Item>Ergebnis: {result.result}
                {roll.as === 'ep' && s_char.value.wunden > 0 && <span> - {s_char.value.wunden} Wunden = {result.result - s_char.value.wunden}</span>}
            </Item>
            {roll.vsnum > 0 && (
                <Item>
                    <div>
                        {result.success ? 'Erfolg' : 'Kein Erfolg'}
                        {result.successes > 0 && <span> +{result.successes} zusätzliche</span>}
                    </div>
                </Item>
            )}
            {roll.vsnum == 0 && (
                <Item>
                    {stepRange?<Chip size={'small'} variant={'outlined'} label={stepRange.difficulty} />:null}
                    {distRange?<Chip size={'small'} variant={'filled'} label={distRange.difficulty}/>:null}
                </Item>
            )}
            <Item>
                <span>Würfel: {die.d6}d6{die.mod !== 0 && (die.mod < 0 ? '' : '+')}{die.mod}</span>
                <span> ({result.rolled})</span>
            </Item>
        </Paper>
    );
};

export default RollerResult;